import { render, staticRenderFns } from "./customerAdd.vue?vue&type=template&id=18daf1ca&scoped=true"
import script from "./customerAdd.vue?vue&type=script&lang=js"
export * from "./customerAdd.vue?vue&type=script&lang=js"
import style0 from "./customerAdd.vue?vue&type=style&index=0&id=18daf1ca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18daf1ca",
  null
  
)

export default component.exports